module.exports = __webpack_public_path__ + "img/liangtang-back-two.a89aa965.png";